import { Component, Input } from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { AdministrarFuncionarioDTO } from 'src/app/models/administrarFuncionario.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';

@Component({
    selector: 'app-informacion-salud-pension-component',
    templateUrl: './informacion-salud-pension.component.html',
    styleUrls: ['./../administrar-funcionarios.component.scss']
})
export class InformacionSaludPensionComponent {

    @Input() datosFuncionario: AdministrarFuncionarioDTO;
    @Input() existeFuncionario: boolean;
    @Input() deshabilitado: boolean;

    constructor() { }
}
